export enum CopilotSuggestedKnowledgeDataEventObject {
  SUGGESTED_KNOWLEDGE_LIST = 'suggested_knowledge_list',
  SUGGESTED_KNOWLEDGE = 'suggested_knowledge',
  SUGGESTED_KNOWLEDGE_PREVIEW = 'suggested_knowledge_preview',
  SUGGESTED_KNOWLEDGE_PREVIEW_DRAFT_RESPONSE = 'suggested_knowledge_preview_draft_response',
  SUGGESTED_KNOWLEDGE_PREVIEW_FEEDBACK = 'suggested_knowledge_preview_feedback',
  SUGGESTED_KNOWLEDGE_SUBMIT_FEEDBACK = 'suggested_knowledge_submit_feedback',
}
